import { dataService } from 'App';

const campaignUrlStart = '/users/campaigns';

/**
 *
 * @param {object} data info about user
 * @return {object} otp of users / error
 */
export function getCampaigns(data) {
  return dataService.get(
    `${campaignUrlStart}/report?search=${data.search}&startDate=${data.startDate}&endDate=${data.endDate}&size=${data.size}&page=${data.page}&sort=${data.sort}`
  );
}

export function getCampaignsDash(data) {
  return dataService.get(
    `${campaignUrlStart}/reportData?search=${data.search}&startDate=${data.startDate}&endDate=${data.endDate}&size=${data.size}&page=${data.page}&sort=${data.sort}`
  );
}

export function pauseCampaign(data) {
  data.campaign.campaignStatus = 'PAUSE';
  return updateCampaignStatus(data);
}

export function cancelCampaign(data) {
  data.campaign.campaignStatus = 'STOP';
  return updateCampaignStatus(data);
}

export function resumeCampaign(data) {
  data.campaign.campaignStatus = 'ACTIVE';
  return dataService.put(
    `${campaignUrlStart}/${data.campaign.campaignId}/resume`,
    data.campaign,
    {}
  );
}

function updateCampaignStatus(data) {
  return dataService.put(
    `${campaignUrlStart}/${data.campaign.campaignId}`,
    data.campaign,
    {}
  );
}

export function createCampaign(data) {
  return dataService.post(`${campaignUrlStart}`, data, {});
}

export function getRecreateCampaign(campaignId) {
  return dataService.get(`${campaignUrlStart}/${campaignId}/recreate`);
}

export function getReport(campaignId) {
  return dataService.get(`${campaignUrlStart}/${campaignId}/report`, {
    headers: {
      'Content-Type': 'arraybuffer',
    },
  });
}

export function sendOtp(data) {
  // console.log("smsContent:" +data.smsContent, "receivers:" +data.receivers);
  // var postData = 'smsContent='+data.smsContent +'&receivers='+data.receivers;
  return dataService.post(`${campaignUrlStart}/otp/send`,data);
}

export const validateOtp = (otp) => {
  var postData = 'otp=' + otp;

  return dataService.post(`${campaignUrlStart}/otp/validate`, postData);
};

export function updateCampaignSendTime(campaignId, time) {
  return dataService.put(
    `${campaignUrlStart}/updateTime/${campaignId}`,
    {
      startDate: time,
    },
    {}
  );
}

export const chechkMinValidSmsWithoutOtp = (smsAmount) => {
  var postData = 'smsAmount=' + smsAmount;
  return dataService.post(
    `${campaignUrlStart}/getMinValidSmsWithoutOtp`,
    postData
  );
};
